// Code generated by apic; DO NOT EDIT.
import { useMemo } from "react";
import { createClient } from "../react/client";
import { getApiToken } from "../react/auth";
import type { ApicClient } from "../react/client";

/**
 * useExplorerClient builds (and memoizes) a ApicClient that reads the ambient
 * bearer token on every request via getApiToken().  The client is re-created only
 * when baseUrl changes, keeping renders stable.
 *
 * The returned client is suitable for use in TryPanel: it forwards the token set
 * by TokenBar → setApiToken through the ambient holder.
 *
 * No web globals at module load time (RN-safe).
 */
export function useExplorerClient(baseUrl?: string): ApicClient {
  return useMemo(
    () =>
      createClient({
        baseUrl: baseUrl ?? "",
        bearerToken: () => getApiToken(),
      }),
    // Re-create only when baseUrl changes. getApiToken is a stable module-level
    // function and does not need to be listed as a dependency.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [baseUrl],
  );
}
